export const STORE_LOCATOR = 'Store Locator';

export const STORE_LISTING_PAGE = 'Store Listing Page';

export const ROADSHOW_LISTING_PAGE = 'Roadshow Listing Page';